import { useCallback, useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';
import type { GsStory } from '@/lib/types';

export default function useStory(slug?: string) {
  const [data, setData] = useState<GsStory | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    if (!slug) {
      setLoading(false);
      setError('This story could not be found.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const { data: row, error: err } = await supabase.from('gs_stories').select('*').eq('slug', slug).maybeSingle();
      if (err) throw err;
      if (!row) throw new Error('This story could not be found.');
      setData(row as GsStory);
    } catch (e) {
      setData(null);
      setError(e instanceof Error ? e.message : 'Unable to load this story.');
    } finally {
      setLoading(false);
    }
  }, [slug]);

  useEffect(() => { load(); }, [load]);

  return { data, loading, error, reload: load };
}